import { configureStore } from "@reduxjs/toolkit";
import { systemSlice, SystemState } from "./system.store";
import { userSlice, UserState } from "./user.store";
import { notificationSlice, NotificationState } from "./notification.store";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Default: localStorage
import { combineReducers } from "redux";

export interface StoreState {
  system: SystemState;
  user: UserState;
  notification: NotificationState;
}

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  system: systemSlice.reducer,
  user: userSlice.reducer,
  notification: notificationSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export default store;
